export default [

    {
        name: 'bars',
        type: 'gltfModel',
        path: '/models/bars.glb'
    },
    {
        name: 'footer',
        type: 'gltfModel',
        path: '/models/footer.glb'
    },
    {
        name: 'logo',
        type: 'gltfModel',
        path: '/models/logo.glb'
    },
    {
        name: 'brit_logo',
        type: 'gltfModel',
        path: '/models/brit_logo.glb'
    },
    {
        name: 'tube',
        type: 'gltfModel',
        path: '/models/tube.glb'
    },
    {
        name: 'balls',
        type: 'texture',
        path: '/images/balls.png'
    },

]
